/* Define theme variables here */

const defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: 'Roboto',
    heading: '"Questrial", "Roboto"'
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],
  fontWeights: {
    body: 400,
    heading: 400,
    bold: 700
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125
  },
  boxShadow: {
    sm: '1px 1px 2px rgba(0,0,0,.3)',
    md: '2px 2px 8px rgba(0,0,0,.3)',
    lg: '0px 0px 12px rgba(0,0,0,.3)'
  },
  breakpoints: {
    xs: 640,
    sm: 768,
    md: 1024,
    lg: 1280
  },
  colors: {
    text: '#333',
    textInverse: '#fefefe',
    background: '#f1f1f1',
    cardBackground: '#fff',
    primary: 'rgb(0, 143, 237)',
    secondary: '#0E2C54',
    success: '#00b440',
    informational: '#00c1f6',
    warning: '#ff9200',
    error: '#ff3e4a',
    disabled: '#ddd',
    greybar: 'rgb(217, 220, 226)',
    footer: 'rgb(252, 252, 254)',
    footerBorder: 'rgb(249, 249, 251)'
  }
}

export default defaultTheme
